import React from "react";
import { ShieldCheck } from "lucide-react";

const tierColor = (score) =>
  score >= 8.5 ? "text-[#10B981] border-[#10B981]/30 bg-[#10B981]/5" :
  score >= 7   ? "text-[#D4AF37] border-[#D4AF37]/30 bg-[#D4AF37]/5" :
  score >= 5   ? "text-[#F5B458] border-[#F5B458]/30 bg-[#F5B458]/5" :
                 "text-[#FF6A60] border-[#FF6A60]/30 bg-[#FF3B30]/5";

const tierLabel = (score) =>
  score >= 8.5 ? "Trusted" : score >= 7 ? "Reliable" : score >= 5 ? "Mixed" : score >= 3 ? "Caution" : "High Risk";

const TrustScore = ({ trust, size = "md", showLabel = true, testId }) => {
  if (!trust) return null;
  const score = trust.score ?? 0;
  const klass = tierColor(score);
  const sizeCls = size === "lg"
    ? "px-4 py-2 text-base"
    : size === "sm" ? "px-2 py-0.5 text-[10px]" : "px-3 py-1 text-xs";
  return (
    <div
      className={`inline-flex items-center gap-2 rounded-full border ${klass} ${sizeCls} font-mono-alt`}
      data-testid={testId || "trust-score-badge"}
    >
      <ShieldCheck className={size === "lg" ? "h-5 w-5" : "h-3.5 w-3.5"} />
      <span className="tabular-nums font-bold">{score.toFixed(1)}</span>
      <span className="opacity-60">/10</span>
      {showLabel && <span className="uppercase tracking-widest opacity-80">· {tierLabel(score)}</span>}
    </div>
  );
};

export default TrustScore;
